//お問い合わせ
$(function () {
  //チェックボックス その他が選ばれた時、その他のテキストエリアを活性化する。
  $(".js-check-disabled-trigger").on("change", function () {
    var trigger = $(this);
    var ancestor = $(".js-check-disabled");
    var textarea = $(".js-check-disabled-textarea");
    var input;

    if (trigger.data("disabled")) {
      input = $(this).closest(ancestor).find(textarea);
    } else {
      input = $(this).closest(ancestor).find(textarea);
    }

    if (trigger.prop("checked") == true && input.prop("disabled") == true) {
      input.prop("disabled", false);
    } else {
      input.prop("disabled", true);
    }
  });

  //ラジオボタン　未開業の場合「年商」〜「事業内容」を非活性にする。
  $(".js-radio-disabled-trigger").on("change", function () {
    var optionClosed;
    var inputsToDisabled = $(".js-radio-disabled-input");

    if ($(this).data("disabled") == "closed") {
      optionClosed = $(this);
    }

    if ($(optionClosed).prop("checked") == true) {
      inputsToDisabled.each(function (i, e) {
        $(e).prop("disabled", true);
      });
    } else {
      inputsToDisabled.each(function (i, e) {
        $(e).prop("disabled", false);
      });
    }
  });

  //ラジオボタン　個人事業主の場合「決算月」を非活性にする。
  $(".js-disabled-trigger").on("change", function () {
    var optionPersonal;
    var toDisabled = $(".js-disabled-input");

    if ($(this).data("disabled") == "personal") {
      optionPersonal = $(this);
    }

    if ($(optionPersonal).prop("checked") == true) {
      toDisabled.each(function (i, e) {
        $(e).prop("disabled", true);
      });
    }
  });

  // バリデーションエラー等でその他のdisabledをチェックする
  // その他初期設定
  // 相談内容
  var messageOther = $(".js-check-disabled-trigger.message");
  var messageOtherTextarea = $(".js-check-disabled-textarea.message");
  if (messageOther.prop("checked") == true && messageOtherTextarea.prop("disabled") == true) {
    messageOtherTextarea.prop("disabled", false);
  }
  // 会計ソフト
  var softwareOther = $(".js-check-disabled-trigger.software");
  var softwareOtherTextarea = $(".js-check-disabled-textarea.software");
  if (softwareOther.prop("checked") == true && softwareOtherTextarea.prop("disabled") == true) {
    softwareOtherTextarea.prop("disabled", false);
  }
  // 事業形態「未開業」
  var business = $(".js-radio-disabled-trigger.business[data-disabled=closed]");
  var businessInputs = $(".js-radio-disabled-input.business");
  if (business.prop("checked") == true) {
    businessInputs.each(function (i, e) {
      $(e).prop("disabled", true);
    });
  }
  // 事業形態「個人事業主」
  var personalBusiness = $(".js-disabled-trigger.business[data-disabled=personal]");
  var personalInputs = $(".js-disabled-input.business");
  if (personalBusiness.prop("checked") == true) {
    personalInputs.each(function (i, e) {
      $(e).prop("disabled", true);
    });
  }

  // メールアドレス（確認用）入力時にペースト入力を抑止する
  $(".js-disabled-paste").on("focus", function () {
    document.body.oncopy = function () {
      return false;
    };
    document.body.onpaste = function () {
      return false;
    };
  });

  // メールアドレス（確認用）入力後（フォーカス外した後）にペースト入力を許可する
  $(".js-disabled-paste").on("blur", function () {
    document.body.oncopy = function () {
      return true;
    };
    document.body.onpaste = function () {
      return true;
    };
  });

  // ヒアリング担当者：検索可能なセレクトボックス
  $(".js-searchable").select2({
    width: "100%",
    allowClear: true,
    multiple: false,
    placeholder: "選択してください",
    language: {
      noResults: function () {
        return "対象が見つかりません";
      }
    },
    theme: "bootstrap"
  });
});
